"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationLoginThirdStep = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _GradientPanel = require("../../atoms/GradientPanel");

var _CarouselImagesLogin = require("../../molecules/CarouselImagesLogin");

var _react = require("react");

var _LogoImage = require("../../atoms/LogoImage");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _variables = require("../../../global-files/variables");

var _TagAndInput = require("../../molecules/TagAndInput");

var _GeneralButton = require("../../atoms/GeneralButton");

var _jsxRuntime = require("react/jsx-runtime");

var RegistrationLoginThirdStep = function RegistrationLoginThirdStep(_ref) {
  var _ref$imageArrayCarous = _ref.imageArrayCarousel,
      imageArrayCarousel = _ref$imageArrayCarous === void 0 ? [] : _ref$imageArrayCarous,
      textCarousel = _ref.textCarousel,
      backogroundColorCarousel = _ref.backogroundColorCarousel;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      emptyCommercialName = _useState2[0],
      setEmptyCommercialName = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      emptyBussinesName = _useState4[0],
      setEmptyBussinesName = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      emptyRFC = _useState6[0],
      setEmptyRFC = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      emptyFiscalAddress = _useState8[0],
      setEmptyFiscalAddress = _useState8[1];

  var validate = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
      var commercialName, bussinesName, RFC, FiscalAddress;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              commercialName = document.querySelector("#commercialNameInput").value;
              bussinesName = document.querySelector("#bussinesNameInput").value;
              RFC = document.querySelector("#rfcInput").value;
              FiscalAddress = document.querySelector("#fiscalAddressInput").value;
              commercialName === "" ? setEmptyCommercialName(true) : setEmptyCommercialName(false);
              bussinesName === "" ? setEmptyBussinesName(true) : setEmptyBussinesName(false);
              RFC === "" ? setEmptyRFC(true) : setEmptyRFC(false);
              FiscalAddress === "" ? setEmptyFiscalAddress(true) : setEmptyFiscalAddress(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function validate(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var loginRight = [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoImage.LogoImage, {}, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "credenciales",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      fontFamily: _variables.FontFamily.AvenirNext,
      color: _variables.GlobalColors.s5,
      text: "Ingresa tus credenciales"
    })
  }, "2"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "user",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
      inputType: "text",
      inputId: "commercialNameInput",
      label: "Nombre comercial",
      inputPlaceHolder: "Nombre comercial"
    }), emptyCommercialName && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ingrese el nombre comercial de la empresa"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
      inputType: "text",
      inputId: "bussinesNameInput",
      label: "Razón social",
      inputPlaceHolder: "Razón social"
    }), emptyBussinesName && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ingrese la raz\xF3n social de la empresa"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
      inputType: "text",
      inputId: "rfcInput",
      label: "RFC",
      inputPlaceHolder: "RFC"
    }), emptyRFC && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "El RFC es requerido"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
      inputType: "text",
      inputId: "fiscalAddressInput",
      label: "Direccion fiscal",
      inputPlaceHolder: "Dirección fiscal"
    }), emptyFiscalAddress && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ingrese la direccion fiscal de la empresa"
    })]
  }, "3"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "button-end",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
      buttonType: "general-default-button",
      label: "Enviar",
      onClick: function onClick(e) {
        return validate(e);
      }
    })
  }, "4"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "progress-bar",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "progress-bar-step-check"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "progress-bar-registration"
    })]
  }, "5"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
    text: "Paso 3",
    headerType: "date-header",
    color: _variables.GlobalColors.s4
  }, "6"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "new-login",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "pre-registro",
      children: ["\xBFYa tienes una cuenta?", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: " Inicia Sesi\xF3n"
      })]
    })
  }, "7")];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "home-retailer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CarouselImagesLogin.CarouselImagesLogin, {
        panelImg: imageArrayCarousel,
        panelText: textCarousel,
        panelColor: backogroundColorCarousel
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "home-login-retailer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GradientPanel.GradientPanel, {
        componentsArray: loginRight,
        panelType: "home-login",
        panelColor: _variables.GlobalColors.white
      })
    })]
  });
};

exports.RegistrationLoginThirdStep = RegistrationLoginThirdStep;